<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <base-material-card color="indigo"
                            icon="mdi-content-copy"
                            title="Edit consignment stock"
                            class="px-5 py-3">
          <br />
          <v-text-field color="primary"
                        label="Status"
                        readonly
                        :value="consignmentStock.status | getStockStatusName"
                        prepend-icon="mdi-message"></v-text-field>
          <v-form class="mt-5" @submit.prevent="update">
            <v-autocomplete v-model="consignmentStock.customer.id"
                            label="Customer"
                            :items="customers"
                            :item-text="customerText"
                            item-value="id"
                            prepend-icon="mdi-account"
                            autocomplete="off"
                            name="customer"
                            data-vv-as="Customer"
                            v-validate="validators.customer"
                            :error="getError('customer')" />
            <v-autocomplete v-model="preDefinedStock"
                            label="Predefined stocks"
                            :items="predefinedStocks"
                            item-text="name"
                            return-object
                            prepend-icon="mdi-database-search"
                            autocomplete="off" />
            <v-row>
              <v-col cols="6">
                <v-menu v-model="startCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="consignmentStock.start"
                                  label="Start"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  name="start date"
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="consignmentStock.start" @input="startCalendar = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="6">
                <v-menu v-model="endCalendar"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="consignmentStock.end"
                                  label="End"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="consignmentStock.end" @input="endCalendar = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            <v-expand-transition>
              <v-list v-if="preDefinedStock.id >= 0">
                <v-list-item v-for="(pq, i) in preDefinedStock.productQuantities" :key="i">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="6" sm="12" class="noBottomTopPaddings">
                        <br />
                        <v-autocomplete v-if="pq.isCustom"
                                        v-model="pq.product.id"
                                        autocomplete="off"
                                        label="Product"
                                        :items="products"
                                        :item-text="text"
                                        item-value="id"
                                        name="product"
                                        data-vv-as="Product"
                                        v-validate="validators.product"
                                        :error="getError('product')" />
                        <div v-if=" !pq.isCustom">
                          <v-list-item-subtitle>Product</v-list-item-subtitle>
                          <v-list-item-title v-text="pq.product.name + ' - ' + pq.product.articleNumber"></v-list-item-title>
                        </div>
                      </v-col>

                      <v-col cols="12" md="5" sm="12" class="noBottomTopPaddings">
                        <br v-if="pq.isCustom" />
                        <v-text-field v-model="pq.quantity"
                                      type="number"
                                      label="Quantity"
                                      name="quantity"
                                      @keypress="onlyInteger"></v-text-field>
                      </v-col>
                      <v-col justify="end" cols="1" class="pa-2 noBottomTopPaddings" align="end">
                        <br />
                        <v-icon @click="removeProductQuantity(i)">mdi-delete</v-icon>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-expand-transition>
            <v-icon class="mb-5" @click="addProductQuantity()">mdi-plus</v-icon>
            <br />
            <v-row justify="center">
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn
                    color="info"
                    min-width="100"
                    width="100%"
                    @click="goBack()"
                    :disabled="buttonsDisabled"
                  >Return</v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn
                    color="error"
                    min-width="100"
                    width="100%"
                    @click="deleteDialog = true"
                    :disabled="buttonsDisabled"
                  >Delete</v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn
                    type="submit"
                    color="success"
                    width="100%"
                    min-width="100"
                    :disabled="buttonsDisabled"
                  >Save</v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" sm="2">
                <v-card-actions class="pl-0">
                  <v-btn
                    color="warning"
                    min-width="100"
                    width="100%"
                    @click="activateStock"
                    :disabled="buttonsDisabled"
                  >Make active</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
    <div class="text-center ma-2">
      <v-snackbar v-model="snackbar" :color="snackColor">
        {{ message }}
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-actions>
          <v-btn color="green darken-1" text @click="deleteDialog = false">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteStock()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import router from "../../../router";
  import axios from "../../../utils/axios";
  import { onlyInteger } from "../../../helpers/inputHelper";
  import {
    getErrorMessageFromException,
    getErrorMessageFromValidation
  } from "../../../helpers/errorHelper";

  export default {
    name: "ConsignmentStocksEdit",
    data: () => ({
      consignmentStock: {
        id: 0,
        errorMessage: String,
        totalValue: 0,
        totalInValue: 0,
        start: new Date().toISOString().substr(0, 10),
        end: new Date().toISOString().substr(0, 10),
        status: 0,
        customer: {
          id: null,
          name: String
        },
        items: []
      },
      validators: {
        customer: {
          required: true
        },
        product: {
          required: true
        }
      },
      preDefinedStock: {
        id: -1,
        name: String,
        productQuantities: [
          {
            id: Number,
            product: {
              name: String,
              productDescription: String,
              articleNumber: String,
              id: Number
            },
            quantity: Number,
            isCustom: Boolean
          }
        ],
        totalValue: Number,
        totalInValue: Number
      },

      customers: [],
      predefinedStocks: [],
      products: [],

      startCalendar: false,
      endCalendar: false,

      snackbar: false,
      message: "",
      snackColor: "error",

      deleteDialog: false,

      buttonsDisabled: false
    }),
    watch: {
      preDefinedStock(newStock, oldStock) {
        for (let i = 0; i < newStock.productQuantities.length; i++) {
          delete newStock.productQuantities[i].isCustom;
        }

        newStock.productQuantities = newStock.productQuantities.filter(
          element => {
            return element.product.id !== null;
          }
        );

        this.consignmentStock.items = newStock.productQuantities;
      }
    },
    created() {
      this.predefinedStocks.push({ id: 0, name: "None", productQuantities: [] });

      this.getCustomers();
      this.getPredefinedStocks();
      this.getConsignmentStock();
      this.getProducts();

      this.preDefinedStock = this.predefinedStocks[0];
    },
    methods: {
      async getCustomers() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get("/Customer");
          if (result) {
            this.customers = result.data;
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackColor = "error";
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },
      async getProducts() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get("/Product");
          if (result) {
            this.products = result.data;
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackColor = "error";
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },
      async getPredefinedStocks() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get("/PreDefinedConsignmentStock");
          if (result) {
            this.predefinedStocks.push(...result.data);
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackColor = "error";
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },
      async getConsignmentStock() {
        let loader = this.$loading.show();
        try {
          var result = await axios.get(
            "/ConsignmentStock/" + this.$route.params.id
          );
          if (result) {
            this.consignmentStock = result.data;
            this.consignmentStock.start = new Date(result.data.start)
              .toISOString()
              .substr(0, 10);
            this.consignmentStock.end = new Date(result.data.end)
              .toISOString()
              .substr(0, 10);

            if (result.data.items.length) {
              this.preDefinedStock.id = 0;
              this.preDefinedStock.productQuantities = result.data.items;
            }

            if (this.consignmentStock.status !== 0) {
              //status 0 = draft
              this.buttonsDisabled = true;
            }
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackColor = "error";
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },
      async deleteStock() {
        this.deleteDialog = false;
        let loader = this.$loading.show();
        try {
          var result = await axios.delete(
            "/ConsignmentStock/" + this.$route.params.id
          );
          if (result) {
            this.$router.go(-1);
          } else {
            throw "Unknown error";
          }
        } catch (exception) {
          this.message = getErrorMessageFromException(exception);
          this.snackColor = "error";
          this.snackbar = true;
        } finally {
          loader.hide();
        }
      },
      async activateStock() {
        this.$validator.validateAll().then(async isValid => {
          if (isValid) {
            let loader = this.$loading.show();
            try {
              for (let i = 0; i < this.consignmentStock.items.length; i++) {
                this.consignmentStock.items[i].quantity = parseInt(
                  this.consignmentStock.items[i].quantity
                );
              }

              var result = await axios.put(
                "/ConsignmentStock/Activate",
                this.consignmentStock
              );
              if (result) {
                this.$router.go(-1);
              } else {
                throw "Unknown error";
              }
            } catch (exception) {
              this.buttonsDisabled = true;
              this.message = getErrorMessageFromException(exception);
              this.snackColor = "error";
              this.snackbar = true;

              setTimeout(() => this.goBack(), 2500);
            } finally {
              loader.hide();
            }
          } else {
            this.message = getErrorMessageFromValidation(this.errors.items);
            this.snackColor = "error";
            this.snackbar = true;
          }
        });
      },
      async update() {
        this.$validator.validateAll().then(async isValid => {
          if (isValid) {
            let loader = this.$loading.show();
            try {
              for (let i = 0; i < this.consignmentStock.items.length; i++) {
                this.consignmentStock.items[i].quantity = parseInt(
                  this.consignmentStock.items[i].quantity
                );
              }

              var result = await axios.put(
                "/ConsignmentStock",
                this.consignmentStock
              );
              if (result) {
                this.consignmentStock = result.data;
                this.consignmentStock.start = new Date(result.data.start)
                  .toISOString()
                  .substr(0, 10);
                this.consignmentStock.end = new Date(result.data.end)
                  .toISOString()
                  .substr(0, 10);

                if (result.data.items.length) {
                  this.preDefinedStock.id = 0;
                  this.preDefinedStock.productQuantities = result.data.items;
                }

                this.snackColor = "success";
                this.message = "Success";
                this.snackbar = true;
              } else {
                throw "Unknown error";
              }
            } catch (exception) {
              this.message = getErrorMessageFromException(exception);

              this.snackColor = "error";
              this.snackbar = true;
            } finally {
              loader.hide();
            }
          } else {
            this.message = this.message = getErrorMessageFromValidation(
              this.errors.items
            );
            this.snackColor = "error";
            this.snackbar = true;
          }
        });
      },

      getError(fieldName) {
        if (this.errors.first(fieldName) !== undefined) {
          return true;
        }
        return false;
      },

      goBack() {
        this.$router.go(-1);
      },

      onlyInteger($event) {
        onlyInteger($event);
      },
      addProductQuantity() {
        this.preDefinedStock.productQuantities.push({
          id: 0,
          product: {
            name: String,
            productDescription: String,
            articleNumber: String,
            id: null
          },
          quantity: 0,
          isCustom: true
        });

        this.consignmentStock.items = this.preDefinedStock.productQuantities;
      },
      removeProductQuantity(index) {
        this.preDefinedStock.productQuantities.splice(index, 1);
      },

      text: item => item.name + " — " + item.articleNumber,
      customerText: customer => customer.name + " — " + customer.customerId
    }
  };
</script>

<style>
  .noBottomTopPaddings {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
</style>
